<template>
  <div>
    <v-simple-table class="table-layout pa-5 pb-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th>Nhân viên</th>
<!--            <th class="fix-width">KH phụ trách</th>-->
            <th>Cuộc gọi thành công</th>
            <th>Thời gian gọi (phút)</th>
            <th>Trung bình cuộc gọi (phút)</th>
            <th class="fix-width">Đơn hàng</th>
            <th>Doanh thu khởi tạo</th>
            <th>ARPU khởi tạo</th>
<!--            <th>Tỷ lệ chốt (%)</th>-->
            <th>Giao hàng thành công (%)</th>
            <th>Doanh thu thành công</th>
            <th>Phiếu thu</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="checkAuthorization('view-total-report_read') && employeeReports.length">
            <td class="total-text">Tổng</td>
<!--            <td class="total-text fix-width">{{ totalReports.countContacts }}</td>-->
            <td class="total-text">{{ totalReports.totalCallSuccess }}</td>
            <td class="total-text">{{ +(totalReports.totalDurationSuccess / 60).toFixed(2) }}</td>
            <td class="total-text">{{ averageCallDuration(totalReports.totalDurationSuccess, totalReports.totalCallSuccess) }}</td>
            <td class="total-text fix-width">{{ totalReports.initCountOrders }}</td>
            <td class="total-text">{{ formatPrice(parseFloat(totalReports.initTurnOver)) }}</td>
            <td class="total-text">{{ formatPrice(Math.round(parseFloat(totalReports.initArpu))) }}</td>
<!--            <td class="total-text">{{ totalReports.initLatch + '%' }}</td>-->
            <td class="total-text">{{ totalReports.successDeliveryRadio + '%' }}</td>
            <td class="total-text">{{ formatPrice(parseFloat(totalReports.successTurnOver)) }}</td>
            <td class="total-text">{{totalReports.countReceipts ? totalReports.countReceipts : '0'}}</td>
          </tr>
          <template v-for="employeeReport in employeeReports">
            <tr
              :key="employeeReport.id"
            >
              <td>{{ employeeReport.fullName }}</td>
<!--              <td class="fix-width">{{ employeeReport.countContacts }}</td>-->
              <td>
                {{ employeeReport.totalCallSuccess }}
              </td>
              <td>
               <div class="d-flex align-center justify-center" style="column-gap: 5px;">
                 <div v-if="employeeReport.updatedAt">
                   <v-tooltip bottom>
                     <template v-slot:activator="{ on, attrs }">
                       <v-icon
                           v-bind="attrs"
                           v-on="on"
                           color="#00cae3"
                       >mdi-alert-circle
                       </v-icon>
                     </template>
                     <span>Dữ liệu phút gọi được cập nhật tính đến: {{employeeReport.updatedAt}}</span>
                   </v-tooltip>
                 </div>
                 <div>
                   {{ +(employeeReport.totalDurationSuccess / 60).toFixed(2) }}
                 </div>
               </div>
              </td>
              <td>{{ averageCallDuration(employeeReport.totalDurationSuccess, employeeReport.totalCallSuccess) }}</td>
              <td class="fix-width">{{ employeeReport.initCountOrders }}</td>
              <td>{{ employeeReport.initTurnOver ?  formatPrice(parseFloat(employeeReport.initTurnOver)) : 0 }}</td>
              <td>{{ formatPrice(Math.round(parseFloat(employeeReport.initArpu))) }}</td>
<!--              <td>{{ +employeeReport.initLatch + '%' }}</td>-->
              <td>{{ employeeReport.successDeliveryRadio + '%' }}</td>
              <td>{{employeeReport.successTurnOver ?  formatPrice(parseFloat(employeeReport.successTurnOver)) : 0}}</td>
              <td>{{employeeReport.countReceipts ? employeeReport.countReceipts : '0'}}</td>
            </tr>
          </template>
        </tbody>
        <!-- <common-no-result
          v-if="!employeeReports.length"
        /> -->
      </template>
    </v-simple-table>

  </div>
</template>
<script>

import { formatPrice } from '@/helpers/utils'
  export default {
    components: {},
    props: {
      employeeReports: {
        type: Array,
        default: () => []
      },
      totalReports: {
        type: Object,
        default: () => {}
      },
      roleName: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        errorMessage: '',
      }
    },
    created () {

    },
    computed: {

    },
    methods: {
      averageCallDuration(totalDurationSuccess, totalCallSuccess) {
        if (totalCallSuccess == 0 || totalDurationSuccess == 0) {
          return 0
        } else {
          return +((totalDurationSuccess / totalCallSuccess) / 60).toFixed(2)
        }
      }
    },
  }
</script>
<style scoped>
.total-text {
  color: #ff5252;
}
.fix-width {
  width: 70px !important;
}
.table-layout table thead tr th {
  font-size: 13px !important;
  min-width: 70px !important;
}
</style>